export default {
  formEl: document.querySelector('.header-form'),
  listEl: document.querySelector('.tasks-list'),
  changeThemBtn: document.querySelector('.theme-toggle-button'),
  body: document.querySelector('body')
};
